import { RootState } from "store/store";

export const getErrorResponseMessage = (state: RootState): string =>
    state.initializationReducer.errorResponseMessage;

export const getErrorEnrollManualStepResponseMessage = (
    state: RootState
): string => state.initializationReducer.errorEnrollManualStepResponseMessage;

export const getErrorMessage = (state: RootState): string =>
    state.initializationReducer.errorResponseMessage ||
    state.initializationReducer.errorMessageInactiveEnvironment ||
    state.initializationReducer.errorMessageInactiveTenant ||
    state.initializationReducer.errorResponseMessageForModal ||
    state.initializationReducer.errorMessageEnrollStep ||
    state.initializationReducer.errorEnrollManualStepResponseMessage ||
    state.initializationReducer.errorTenantDeleteMessage;

export const getIsLoaderVisible = (state: RootState): boolean =>
    state.initializationReducer.loadersCount > 0;

export const getIsErrorResponseMessageVisible = (state: RootState): boolean =>
    getErrorResponseMessage(state).length > 0;
